<template>
  <div class="">
    <template v-if="options" class="uk-select">
      <div class="inline-flex items-center space-x-2 border rounded-lg p-1">
        <div class="flex space-x-2">
          <!-- Hızlı Not -->
          <VDropdown :shown="fastNoteToggle" @hide="fastNoteToggle = false">
            <span class="cursor-pointer flex text-xs space-x-2 items-center" title="Hızlı not ekle">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-4 h-4"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-2-7H7v-2h10v2zm-4 4H7v-2h6v2zm4-8H7V6h10v2z"
                />
              </svg>
            </span>
            <template #popper>
              <div class="p-3 w-72">
                <h2 class="text-sm font-semibold mb-2">Hızlı Not Ekle</h2>
                <form @submit.prevent="saveFastNote()">
                  <textarea
                    v-model="fastNoteBody"
                    class="uk-textarea w-full text-sm"
                    rows="3"
                    placeholder="Notunuzu buraya yazın..."
                    autofocus
                  ></textarea>
                  <div class="flex justify-end mt-2 space-x-2">
                    <button
                      type="button"
                      class="px-3 py-1 text-xs text-gray-600 hover:bg-gray-100 rounded"
                      @click="fastNoteToggle = false"
                      v-close-popper
                    >
                      İptal
                    </button>
                    <button
                      type="submit"
                      class="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center"
                      :disabled="savingNote"
                    >
                      <vk-spinner v-if="savingNote" ratio="0.4" class="mr-1"></vk-spinner>
                      Kaydet
                    </button>
                  </div>
                </form>
              </div>
            </template>
          </VDropdown>
          <!-- Hızlı Arama -->
          <VDropdown :shown="fastCallToggle">
            <span class="cursor-pointer flex text-xs space-x-2  items-center">
              <svg
                title="Hızlı arama"
                alt="Hızlı arama"
                xmlns="http://www.w3.org/2000/svg"
                class="w-4 h-4"
                viewBox="0 0 24 24"
              >
                <g fill="currentColor" fill-rule="evenodd" clip-rule="evenodd">
                  <path
                    d="M22.75 7a5.75 5.75 0 1 0-10.9 2.56a.129.129 0 0 1 .013.04v.007l-.297 1.113a1.4 1.4 0 0 0 1.714 1.714l1.113-.298c-.002 0-.001 0 0 0h.007a.126.126 0 0 1 .04.014A5.75 5.75 0 0 0 22.75 7m-8.356 5.136h-.002zM17 2.75a4.25 4.25 0 1 1-1.892 8.057a1.567 1.567 0 0 0-1.102-.12l-.946.253l.253-.946a1.566 1.566 0 0 0-.12-1.102A4.25 4.25 0 0 1 17 2.75"
                  />
                  <path
                    d="M17 4.25a.75.75 0 0 1 .75.75v1.25H19a.75.75 0 0 1 0 1.5h-1.25V9a.75.75 0 0 1-1.5 0V7.75H15a.75.75 0 0 1 0-1.5h1.25V5a.75.75 0 0 1 .75-.75M3.007 6.407c1.68-1.68 4.516-1.552 5.685.544l.65 1.163c.763 1.368.438 3.095-.68 4.227a.63.63 0 0 0-.104.337c-.013.256.078.849.997 1.767c.918.918 1.51 1.01 1.767.997a.63.63 0 0 0 .337-.104c1.131-1.118 2.859-1.443 4.227-.68l1.163.65c2.096 1.17 2.224 4.005.544 5.685c-.899.898-2.094 1.697-3.498 1.75c-2.08.079-5.536-.459-8.958-3.88c-3.421-3.422-3.959-6.877-3.88-8.958c.053-1.405.852-2.6 1.75-3.498m4.376 1.275c-.6-1.074-2.21-1.32-3.315-.214c-.775.775-1.28 1.63-1.312 2.493c-.066 1.736.363 4.762 3.442 7.841c3.08 3.08 6.105 3.508 7.84 3.442c.863-.033 1.72-.537 2.494-1.312c1.106-1.106.86-2.716-.214-3.315l-1.163-.649c-.723-.403-1.74-.266-2.452.448c-.07.07-.517.486-1.308.524c-.81.04-1.791-.324-2.9-1.434c-1.111-1.11-1.475-2.091-1.435-2.902c.038-.791.455-1.237.524-1.306c.714-.714.851-1.73.448-2.453z"
                  />
                </g>
              </svg>
            </span>
            <template #popper>
              <div class="p-2 divide-y w-40">
                <div class="text-sm cursor-pointer  p-2" @click="makeCall(0)">
                  <span>0 hattı</span>
                  <vk-spinner
                    v-if="loadingHat == 'hat0'"
                    ratio="0.5"
                  ></vk-spinner>
                </div>
                <div class="text-sm cursor-pointer p-2" @click="makeCall(80)">
                  <span>80 hattı</span>
                  <vk-spinner
                    v-if="loadingHat == 'hat80'"
                    ratio="0.5"
                  ></vk-spinner>
                </div>
                <div class="text-sm  cursor-pointer  p-2" @click="makeCall(90)">
                  <span>90 hattı</span>
                  <vk-spinner
                    v-if="loadingHat == 'hat90'"
                    ratio="0.5"
                  ></vk-spinner>
                </div>
                <div
                  v-for="prefix in $root.cache.callPrefixes"
                  :key="prefix.value"
                  class="text-sm cursor-pointer p-2"
                  @click="makeCall(prefix.value)"
                >
                  <span>{{ prefix.label }}</span>
                  <vk-spinner
                    v-if="loadingHat == 'hat' + prefix.value"
                    ratio="0.5"
                  ></vk-spinner>
                </div>
                <div class="pt-2 text-gray-500">
                  <span class="text-xs block w-60" v-if="!$root.cache.me.dahili"
                    >Bu özellik çalışabilmesi için
                    <a href="/profile">profilinizde</a> dahiliniz tanımlı
                    olmalıdır. {{ $root.cache.me.dahili }}</span
                  >
                  <span class="text-xs">
                    Birinci telefon bölümünde yazılı telefon önceliklidir, orası
                    boş ise telefon 2 kısımındaki numarayı arayacaktır.</span
                  >
                </div>
              </div>
            </template>
          </VDropdown>
          <VDropdown :shown="isOpenVDropdown">
            <span class="cursor-pointer flex text-xs space-x-2  items-center">
              <svg
                title="Hızlı durum değiştirme"
                alt="Hızlı durum değiştirme"
                xmlns="http://www.w3.org/2000/svg"
                class="w-4 h-4"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  fill-rule="evenodd"
                  d="M11.943 1.25H13.5a.75.75 0 0 1 0 1.5H12c-2.378 0-4.086.002-5.386.176c-1.279.172-2.05.5-2.62 1.069c-.569.57-.896 1.34-1.068 2.619c-.174 1.3-.176 3.008-.176 5.386s.002 4.086.176 5.386c.172 1.279.5 2.05 1.069 2.62c.57.569 1.34.896 2.619 1.068c1.3.174 3.008.176 5.386.176s4.086-.002 5.386-.176c1.279-.172 2.05-.5 2.62-1.069c.569-.57.896-1.34 1.068-2.619c.174-1.3.176-3.008.176-5.386v-1.5a.75.75 0 0 1 1.5 0v1.557c0 2.309 0 4.118-.19 5.53c-.194 1.444-.6 2.584-1.494 3.479c-.895.895-2.035 1.3-3.48 1.494c-1.411.19-3.22.19-5.529.19h-.114c-2.309 0-4.118 0-5.53-.19c-1.444-.194-2.584-.6-3.479-1.494c-.895-.895-1.3-2.035-1.494-3.48c-.19-1.411-.19-3.22-.19-5.529v-.114c0-2.309 0-4.118.19-5.53c.194-1.444.6-2.584 1.494-3.479c.895-.895 2.035-1.3 3.48-1.494c1.411-.19 3.22-.19 5.529-.19m4.827 1.026a3.503 3.503 0 0 1 4.954 4.953l-6.648 6.649c-.371.37-.604.604-.863.806a5.34 5.34 0 0 1-.987.61c-.297.141-.61.245-1.107.411l-2.905.968a1.492 1.492 0 0 1-1.887-1.887l.968-2.905c.166-.498.27-.81.411-1.107c.167-.35.372-.68.61-.987c.202-.26.435-.492.806-.863zm3.893 1.06a2.003 2.003 0 0 0-2.832 0l-.376.377c.022.096.054.21.098.338c.143.413.415.957.927 1.469a3.875 3.875 0 0 0 1.807 1.025l.376-.376a2.003 2.003 0 0 0 0-2.832m-1.558 4.391a5.397 5.397 0 0 1-1.686-1.146a5.395 5.395 0 0 1-1.146-1.686L11.218 9.95c-.417.417-.58.582-.72.76a3.84 3.84 0 0 0-.437.71c-.098.203-.172.423-.359.982l-.431 1.295l1.032 1.033l1.295-.432c.56-.187.779-.261.983-.358c.251-.12.49-.267.71-.439c.177-.139.342-.302.759-.718z"
                  clip-rule="evenodd"
                />
              </svg>
            </span>
            <!-- This will be the content of the popover -->
            <template #popper> 
              <h2 class="text-sm p-0 pl-2 pt-2 m-0">Lead Durum Değiştirme</h2>
              <form @submit.prevent="saveLeadStatus(rowall.id, newstatus)">
                <div class="flex items-center text-xs p-2 space-x-2">
                  <select v-if="options" class="uk-select" v-model="newstatus">
                    <option value selected>Select</option>
                    <option
                      :value="option.value"
                      v-for="option in $root.cache.getOptions[input.id]"
                      >{{ option.label }}
                    </option>
                  </select>
                  <savebutton title="Kaydet" action="faststatusUpdate" />
                </div>
              </form>
            </template>
          </VDropdown>
        </div>
        <div
          class="
        px-3 inline-flex text-xs leading-5 text-center font-semibold rounded   
        "
          :style="
            '   background:' +
              findValue().background +
              '; color:' +
              findValue().color +
              ';'
          "
        >
          {{ findValue().label }}
        </div>
      </div>
    </template>

    <template v-else>
      <vk-spinner></vk-spinner>
    </template>
  </div>
</template>

<script>
import EventBus from "../EventBus";
import httpService from "../../../services/http";
export default {
  name: "leadStatus",
  data() {
    return {
      model: null,
      options: null,
      fastCallToggle: false,
      isOpenVDropdown: false,
      newstatus: null,
      loadingHat: "",
      fastNoteToggle: false,
      fastNoteBody: "",
      savingNote: false,
    };
  },
  props: ["input", "form", "rowdata", "rowall"],
  created() {
    this.model = this.rowdata;
    this.newstatus = this.model;
  },
  methods: {
    saveFastNote() {
      if (!this.fastNoteBody || !this.fastNoteBody.trim()) {
        this.$root.errorMessage("Not içeriği zorunludur");
        return;
      }

      this.savingNote = true;
      EventBus.$emit("loadingStatus", {
        action: "fastNoteAdd",
        loading: true,
      });

      const noteData = {
        lead_id: this.rowall.id,
        body: this.fastNoteBody.trim(),
        agents: [
          {
            label: localStorage.getItem("userName"),
            value: localStorage.getItem("userId"),
          },
        ],
      };

      httpService
        .inlineSave({
          table: "lead_notes",
          type: "insert_note",
          inputs: noteData,
        })
        .then((resp) => {
          if (resp.data.success) {
            this.$root.successMessage("Not başarıyla kaydedildi");
            this.fastNoteBody = "";
            this.fastNoteToggle = false;
            EventBus.$emit("getNote");
          } else {
            this.$root.errorMessage("Not kaydedilemedi");
          }
        })
        .catch(() => {
          this.$root.errorMessage("İşlem başarısız, lütfen tekrar deneyin");
        })
        .finally(() => {
          this.savingNote = false;
          EventBus.$emit("loadingStatus", {
            action: "fastNoteAdd",
            loading: false,
          });
        });
    },
    makeCall(ek) {
      this.loadingHat = "hat" + ek;
      httpService
        .makeFastCall({
          hat: ek,
          lead_id: this.rowall.id,
        })
        .then((resp) => {
          this.loadingHat = "";
          console.log(resp, "resp");
        })
        .catch((e) => {
          this.loadingHat = "";
        });
    },
    saveLeadStatus(id, val) {
      EventBus.$emit("loadingStatus", {
        action: "faststatusUpdate",
        loading: true,
      });
      httpService
        .fastStatusUpdate(id, {
          status_id: val,
        })
        .then((e) => {
          this.isOpenVDropdown = false;
          this.model = this.newstatus;
          EventBus.$emit("loadingStatus", {
            action: "faststatusUpdate",
            loading: false,
          });
        });
    },
    findValue() {
      if (this.model) {
        return this.options.find((val) => val.value === this.model);
      }
    },
  },
  mounted() {
    if (this.input.id > 0) {
      this.options = this.$root.cache.getOptions[this.input.id];
    }
  },
  watch: {
    form() {
      if (this.form) {
        this.model = null;
      }
    },
    model() {
      this.$parent.$emit("change", {
        name: this.input.name,
        value: this.model,
      });
    },
  },
};
</script>
